(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-j29-back]').forEach((button) => {
      const label = button.querySelector('[data-j29-back-label]');
      let backLabel = 'Back';

      if (document.referrer) {
        try {
          const referrerUrl = new URL(document.referrer);
          const referrerPath = referrerUrl.pathname.toLowerCase();

          if (referrerPath.includes('shop-by-mascot')) {
            backLabel = 'Back to Mascots';
          } else if (referrerPath.includes('shop-all-teams')) {
            backLabel = 'Back to All Teams';
          } else if (referrerPath.includes('/pages/school/')) {
            backLabel = 'Back to School';
          } else if (referrerPath.includes('shop-all-schools')) {
            backLabel = 'Back to All Schools';
          }
        } catch (error) {
          backLabel = 'Back';
        }
      }

      if (label) label.textContent = backLabel;

      button.addEventListener('click', () => {
        if (document.referrer && document.referrer !== window.location.href) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
